import Button from "@/components/ui/components/Button";
import React from "react";

const SubscribeComponent = () => {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg bg-gray-100 p-4">
        <div className="mb-4 text-lg font-semibold text-[#2D2D2D]">Get Latest Updates</div>
        <form className="flex w-full flex-col items-center justify-center gap-3">
          <input
            type="email"
            placeholder="Enter Email Address"
            className="w-full rounded-lg p-2 text-xs outline-none"
            // readOnly
            required
          />
          <Button
            text="Subscribe"
            filledColor="bg-gray-800"
            rounded={false}
            align="text-center"
            fontSize="text-sm"
            fontWeight="font-medium font-inter"
            paddingX="px-4"
            paddingY="py-1"
          />
        </form>
      </div>
  );
};

export default SubscribeComponent;
